import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

export const ResourceFieldDetailDirectiveModule = angular
  .module('acme.common.directive.resourceFieldDetail', ['acme.common.service.helpers'])
  .directive('resourceFieldDetail', [
    'HelpersService',
    function ResourceFieldDetailDirective(HelpersService: TODO) {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/resourceField/detail/detail.tpl.html',
        scope: {
          field: '=',
          entity: '=',
          fieldIndex: '@fieldindex',
          resourceTemplateId: '@resourcetemplateid',
          disableEdit: '@disableedit',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ResourceFieldDetailController(
            $scope: IScope & { resourceFieldDetail: TODO; disableEdit: TODO; field: TODO; fieldIndex: TODO }
          ) {
            $scope.resourceFieldDetail = {
              hasDefaultValue: false,

              edit: function () {
                if (!$scope.disableEdit) {
                  $scope.$emit('resourceField::stateChange', { state: 'edit' });
                }
              },

              remove: function () {
                $scope.$emit('resourceFieldDetail::remove', { field: $scope.field, index: $scope.fieldIndex });
              },

              getStringArrayValue: function () {
                console.log(typeof $scope.field.stringArrayValue, $scope.field.stringArrayValue);
                return typeof $scope.field.stringArrayValue === 'string'
                  ? HelpersService.stringToArray($scope.field.stringArrayValue)
                  : $scope.field.stringArrayValue;
              },

              getFieldValue: function (field) {
                const value = HelpersService.getFieldValue(field, true);

                this.hasDefaultValue = value;
                console.log(this.hasDefaultValue);
                return this.hasDefaultValue ? value : 'No Default Value';
              },

              getFieldType: function (field) {
                console.log(HelpersService.getFieldType(field));
                return HelpersService.cap(HelpersService.getFieldType(field).simpleType);
              },
            };
          },
        ],
      };
    },
  ]).name;
